import React from 'react';
import { motion } from 'framer-motion';
import SphereRocketLogo from '../assets/SphereRocketLogo';

const SuperchargedSuccess = () => {
  // Benefits lists
  const coreBenefits = [
    "3-4 week deployment",
    "Your 1:1 coach",
    "VA's 1:1 coach",
    "Lifetime replacements",
    "Quarterly masterminds",
    "Retention team",
    "American customer service representative"
  ];
  
  const eliteTraining = [
    "500+ videos",
    "Live coaching (10x/week)",
    "In-person events",
    "SOP library",
    "Multi-hire discounts"
  ];
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section id="supercharged" className="section bg-white">
      <div className="container">
        <motion.div
          className="text-center mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-primary-700 mb-4">Supercharged Success</h2>
          <h3 className="text-accent-600 text-xl md:text-2xl mb-8">When You Hire Through Smooth Staffing, Your VA Gains Elite Training & Support</h3>
          
          {/* Sphere Rocket Logo */}
          <motion.div 
            className="flex justify-center my-10"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <div className="w-48 md:w-64">
              <SphereRocketLogo className="w-full h-auto" alt="Sphere Rocket" />
            </div>
          </motion.div>
          
          <p className="text-neutral-600 text-lg max-w-3xl mx-auto mt-10">
            Through our exclusive partnership with Sphere Rocket, your virtual assistant receives unparalleled resources to drive your business forward. 
            We provide white-glove recruitment with 3-4 week deployment, dedicated coaching for both you and your VA, and continuous skill development through 
            Sphere Rocket's industry-leading programs - transforming support into strategic growth.
          </p>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-10 mb-12">
          {/* Core Benefits Column */}
          <motion.div 
            className="md:w-1/2 w-full"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <div className="bg-primary-50 rounded-2xl p-8 h-full shadow-soft">
              <h4 className="text-primary-700 text-xl font-bold mb-6 text-center">Core Benefits</h4>
              <ul className="space-y-4">
                {coreBenefits.map((benefit, index) => (
                  <motion.li 
                    key={index} 
                    className="flex items-center"
                    variants={itemVariants}
                  >
                    <svg className="w-5 h-5 text-accent-600 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-neutral-700 text-left">{benefit}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>
          
          {/* Elite Training Resources Column */}
          <motion.div 
            className="md:w-1/2 w-full"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <div className="bg-primary-50 rounded-2xl p-8 h-full shadow-soft">
              <h4 className="text-primary-700 text-xl font-bold mb-6 text-center">Elite Training Resources</h4>
              <ul className="space-y-4">
                {eliteTraining.map((resource, index) => (
                  <motion.li 
                    key={index} 
                    className="flex items-center"
                    variants={itemVariants}
                  >
                    <svg className="w-5 h-5 text-accent-600 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-neutral-700 text-left">{resource}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>

        <motion.div 
          className="text-center mt-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <a 
            href="https://calendly.com/adam-cothes/va-consultation" 
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Book a Call
          </a>
        </motion.div>
    </section>
  );
};

export default SuperchargedSuccess;